import { createContext, useContext } from "react";

export const OperationsPrefetchContext = createContext<((href: string) => void) | null>(null);

export function useOperationsPrefetch() {
  return useContext(OperationsPrefetchContext);
}
